export default {
  align: 'start',
  draggable: false
}
